import React, { useState, useEffect, CSSProperties } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import PapelPicado from './components/PapelPicado';
import BannerPatrio from './components/BannerPatrio';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppFloat from './components/WhatsAppFloat';
import PhoneFloat from './components/PhoneFloat';
import Banner from './components/Banner';
import BannerPromocional from './components/BannerPromocional';
import MenuSection from './components/MenuSection';
import Contacto from './components/Contacto';
import Sucursales from './pages/Sucursales';
import MainMenu from './pages/Menus/MainMenu';
import MenuMesa from './pages/Menus/MenuMesa';
import MenuParaLlevar from './pages/Menus/MenuParaLLevar';
import Nosotros from './pages/Nosotros';
import Opiniones from './pages/Opiniones';
import Terminos from './pages/Terminos';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
  const location = useLocation();
  const [animationStyle, setAnimationStyle] = useState<CSSProperties>({
    opacity: 0,
    transform: 'translateY(30px)',
  });

  useEffect(() => {
    setAnimationStyle({ opacity: 0, transform: 'translateY(30px)' });
    const timeout = setTimeout(() => {
      setAnimationStyle({ opacity: 1, transform: 'translateY(0)', transition: 'all 0.6s ease-out' });
    }, 100);
    return () => clearTimeout(timeout);
  }, [location]);

  return (
    <>
      <Helmet>
        <title>El Chel | Cochinita Pibil</title>
        <meta name="description" content="El Chel — Cochinita pibil desde 1978. Tacos, panuchos, paella y más en Tlalpan, CDMX. Tres sucursales." />
        {/* Open Graph / WhatsApp / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.elchel.mx/" />
        <meta property="og:title" content="El Chel | Cochinita Pibil desde 1978" />
        <meta property="og:description" content="El Chel — Cochinita pibil, tacos, paella y más en Tlalpan, CDMX. Tres sucursales. ¡Pide por WhatsApp!" />
        <meta property="og:image" content="https://www.elchel.mx/sep/redes.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="El Chel" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="El Chel | Cochinita Pibil desde 1978" />
        <meta name="twitter:description" content="El Chel — Cochinita pibil, tacos, paella y más en Tlalpan, CDMX." />
        <meta name="twitter:image" content="https://www.elchel.mx/sep/redes.jpg" />
      </Helmet>

      <ScrollToTop />
      <Navbar />

      <div className="pt-[100px]" style={animationStyle}>
        <PapelPicado />
        <BannerPatrio />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <BannerPromocional />
                <Banner />
                <PapelPicado />
                <MenuSection />
                <PapelPicado />
                <Opiniones />
                <Contacto />
              </>
            }
          />
          <Route path="/sucursales" element={<Sucursales />} />
          <Route path="/menu" element={<MainMenu />} />
          <Route path="/menuMesa" element={<MenuMesa />} />
          <Route path="/menuparallevar" element={<MenuParaLlevar />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/opiniones" element={<><Opiniones /><Contacto /></>} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <WhatsAppFloat />
      <PhoneFloat />
    </>
  );
};

export default App;
